import { getDateValue } from '../utils/firebase';

export class DiscountProductInfo {
	id = null;
	variantId = null;
	name = null;
	categories = [];
	price = null;

	constructor(data) {
		this.id = data.id;
		this.variantId = data.variantId;
		this.name = data.name;
		this.categories = data.categories || [];
		this.price = data.price;
	}

	static fromVariant(variant) {
		return new DiscountProductInfo({
			id: variant.productId,
			variantId: variant.id,
			name: variant.name,
			categories: variant.categories || [],
			price: variant.price,
		});
	}
}
export class DiscountCollectionInfo {
	id = null;
	name = null;

	constructor(data) {
		this.id = data.id;
		this.name = data.name;
	}
}
export class DiscountCustomerInfo {
	id = null;
	name = null;
	email = null;

	constructor(data) {
		this.id = data.id;
		if (data.name) {
			this.name = data.name;
		} else if (data.firstName) {
			this.name = `${data.firstName} ${data.lastName}`;
		}
		this.email = data.email;
	}
}

export class DiscountCityInfo {
	id = null;
	name = null;
	state = null;
	storeName = null;

	constructor(data) {
		this.id = data.id;
		this.name = data.name;
		this.state = data.state;
		this.storeName = data.storeName;
	}
}

export class Discount {
	id = null;
	title = null;
	description = null;
	type = null;
	subType = null;
	appliesTo = null;
	couponCode = null;
	discountType = null;
	discountValue = null;
	maxDiscountAmount = null;
	minimumRequirement = null;
	minimumAmount = null;
	minimumQuantity = null;
	eligibility = null;
	selectedCustomers = [];
	selectedProducts = [];
	selectedCollections = [];
	selectedSegments = [];
	selectedVariants = [];
	maxUsesTotal = null;
	maxUsesPerCustomer = null;
	currentUsage = 0;
	combinationsAllowed = {
		order: true,
		product: true,
		shipping: true,
	};
	startDate = null;
	endDate = null;
	isActive = null;
	createdAt = null;
	updatedAt = null;
	lastUsed = null;

	constructor(data) {
		Object.assign(this, data);

		this.startDate = getDateValue(this.startDate);
		this.endDate = getDateValue(this.endDate);
		this.createdAt = getDateValue(this.createdAt);
		this.updatedAt = getDateValue(this.updatedAt);
	}
}

export const discountTypes = {
	AmountOfProducts: 'amount_of_products',
	Order: 'order',
	Shipping: 'shipping',
	BuyXGetY: 'buy_x_get_y',
};
